import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './TiendaSocial.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleDoubleRight,
    faStore,
    faArrowRight,
    faFire,
    faChevronLeft,
    faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import 'react-toastify/dist/ReactToastify.css';
import LoadingTiendas from '../LoadingTiendas/LoadingTiendas';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function TiendaSocial() {
    const [loading, setLoading] = useState(true);
    const [tiendas, setTiendas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [categoriasTienda, setCategoriasTienda] = useState([]);
    const [categoriasProd, setCategoriasProd] = useState([]);
    const swipersRef = useRef({});

    useEffect(() => {
        cargarTiendas();
        cargarCategorias();
    }, []);

    const cargarTiendas = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const tiendasData = data.tiendas || [];
                const tiendasConProductos = tiendasData.filter(t => t?.productos && t.productos.length > 0);
                setTiendas(tiendasConProductos.sort(() => 0.5 - Math.random()).slice(0, 2));
                const productosTienda = tiendasData.flatMap(tienda => tienda?.productos || []).filter(Boolean);
                setProductos(productosTienda);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriaTiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoriasTienda(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías de tienda:', error));

        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoriasProd(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías de productos:', error));
    };

    const obtenerImagen = (item) => {
        if (!item) return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
        if (item.imagen1) return item.imagen1;
        if (item.imagen2) return item.imagen2;
        if (item.imagen3) return item.imagen3;
        if (item.imagen4) return item.imagen4;
        return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
    };

    if (loading) {
        return null;
    }

    return (
        <div className='TiendaContain TiendaSocialContain'>
            {tiendas.map(item => {
                const prodsDeTienda = productos.filter(p => p.idTienda === item.idTienda);
                if (prodsDeTienda.length === 0) return null;

                const catTienda = categoriasTienda.find(c => Number(c.idCategoria) === Number(item.idCategoria));
                const nombreCatTienda = catTienda?.categoria;
                const slugTienda = encodeURIComponent((item.nombre || 'tienda').trim().replace(/\s+/g, '-'));

                return (
                    <div key={item.idTienda} className="tiendaSocialBlock">
                        <div className="tiendaSocialHeader">
                            <Anchor className='tiendaSocialHeaderLink' to={`/tienda/${item.idTienda}/${slugTienda}`}>
                                <img
                                    src={item.imagen1 || 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60'}
                                    alt={item.nombre}
                                    className='tiendaSocialLogo'
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60';
                                    }}
                                />
                                <div className='tiendaSocialHeaderInfo'>
                                    <h4>{item.nombre}</h4>
                                    {nombreCatTienda && (
                                        <span className='tiendaSocialCatBadge'>{nombreCatTienda}</span>
                                    )}
                                </div>
                            </Anchor>
                            <div className='tiendaSocialHeaderActions'>
                                <div className='carouselNavControls'>
                                    <button
                                        type='button'
                                        className='carouselNavBtn'
                                        onClick={() => swipersRef.current[item.idTienda]?.slidePrev()}
                                        title='Productos anteriores'
                                        aria-label='Productos anteriores'
                                    >
                                        <FontAwesomeIcon icon={faChevronLeft} />
                                    </button>
                                    <button
                                        type='button'
                                        className='carouselNavBtn'
                                        onClick={() => swipersRef.current[item.idTienda]?.slideNext()}
                                        title='Siguientes productos'
                                        aria-label='Siguientes productos'
                                    >
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </button>
                                </div>
                                <Anchor className='btnVerTiendaSocial' to={`/tienda/${item.idTienda}/${slugTienda}`}>
                                    <span>Ver tienda</span>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Anchor>
                            </div>
                        </div>

                        <Swiper
                            onSwiper={(swiper) => {
                                swipersRef.current[item.idTienda] = swiper;
                            }}
                            grabCursor={true}
                            slidesPerView={'auto'}
                            spaceBetween={16}
                            watchOverflow={true}
                            observer={true}
                            observeParents={true}
                            autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
                            className='swiperTiendaSocialProducts'
                        >
                            {prodsDeTienda.map(prod => {
                                const slugProd = encodeURIComponent((prod.titulo || 'producto').trim().replace(/\s+/g, '-'));
                                const catProd = categoriasProd.find(c => Number(c.idCategoria) === Number(prod.idCategoria));
                                const badgeLabel = prod.masVendido === 'si' ? 'Más Vendido' : (catProd?.categoria || 'Producto');

                                return (
                                    <SwiperSlide key={prod.idProducto} className='slideProductSocial'>
                                        <Anchor
                                            to={`/producto/${prod.idProducto}/${slugProd}`}
                                            className='cardProductoTiendaStyle'
                                            title={prod.titulo}
                                        >
                                            <div className='imgProductoBannerWrapper'>
                                                <img
                                                    src={obtenerImagen(prod)}
                                                    alt={prod.titulo || 'imagen'}
                                                    className='imgProductoBanner'
                                                    loading="lazy"
                                                    decoding="async"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
                                                    }}
                                                />
                                                <span className={`categoriaBadgeProducto ${prod.masVendido === 'si' ? 'badgeMasVendido' : ''}`}>
                                                    {prod.masVendido === 'si' && (
                                                        <FontAwesomeIcon icon={faFire} style={{ marginRight: '4px' }} />
                                                    )}
                                                    {badgeLabel}
                                                </span>
                                                <span className='badgePrecioProducto'>
                                                    <span className='precioNumero'>
                                                        {moneda} {String(prod?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                    </span>
                                                    {prod.precioAnterior >= 1 && prod.precioAnterior !== undefined && (
                                                        <span className='precioAnteriorBadge'>
                                                            {moneda} {`${prod?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </span>
                                                    )}
                                                </span>
                                            </div>

                                            <div className='cardTextProductoTienda'>
                                                <img
                                                    src={item.imagen1 || 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60'}
                                                    alt={item.nombre}
                                                    className='CardlogoTiendaProducto'
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60';
                                                    }}
                                                />
                                                <div className='cardTextInfoProducto'>
                                                    <h4 title={prod.titulo}>{prod.titulo}</h4>
                                                    <h5 title={item.nombre}>
                                                        <FontAwesomeIcon icon={faStore} style={{ marginRight: '5px', fontSize: '11px', color: '#94a3b8' }} />
                                                        {item.nombre}
                                                    </h5>
                                                    {prod.descripcion && (
                                                        <p className='cardProductDesc'>{prod.descripcion}</p>
                                                    )}
                                                </div>
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>
                                        </Anchor>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                );
            })}
        </div>
    );
}
